import { ErrorMessage, Field, FormikState, FormikValues, useFormikContext } from "formik"
import { wpInitialValueData } from "../TemplateRegister";

const TemplateFooter = () => {
    const { values, touched, errors }: FormikState<wpInitialValueData> = useFormikContext();

    return (
        <div className="row mt-3">
            <label className="col-form-label fw-semibold fs-6">Footer</label>

            <div className="col-12 col-xl-9  fv-row">
                {values.category != "authentication" && <><Field
                    type="text"
                    className={`form-control form-control-lg form-control-solid
                    ${touched.footer?.text && errors.footer?.text && "is-invalid inValidBorder"}`}
                    placeholder="Footer"
                    id="footer.text"
                    name="footer.text"
                />
                <ErrorMessage name="footer.text" component="div" className="errorMsg" /></>}
                <div className="col-12 col-xl-4  fv-row">
                {values.category == "authentication" && <><Field
                    type="number"
                    className="form-control form-control-lg form-control-solid mt-3"
                    placeholder="Code Expiration (minutes)"
                    id="footer.code_expiration_minutes"
                    name="footer.code_expiration_minutes"
                  />
                <ErrorMessage name="footer.code_expiration_minutes" component="div" className="errorMsg" /></>}
                </div>
            </div>
        </div>
    )
}

export default TemplateFooter